import { ChangeEvent, ClickEvent, DataSourceMode, Tab } from "@mcleod/components";
import { DateRange, LogManager, ModelRow } from "@mcleod/core";
import { ExpandableFilterController } from "@mcleod/general";
import { AutogenLayoutMobileCommPositionList } from "./autogen/AutogenLayoutMobileCommPositionList";

const log = LogManager.getLogger("lme.dispatch.mobilecomm.MobileCommPositionList");

export interface MobileCommUrlProps {
    key?: string;
    tab: number;
    id: string;
}

export class MobileCommPositionList extends AutogenLayoutMobileCommPositionList {
    private expandableFilter: ExpandableFilterController = new ExpandableFilterController();
    private _unfilteredData: ModelRow[];
    private props: MobileCommUrlProps;
    mapAllLandmarks: () => void;

    async onLoad() {
        this.switchCurrentPositions.checked = true;
        this.sourceMobileCommPosition.orderBy = [{ field: "unit", sort: "asc" }];
        this.setupExpandableFilter();
    }

    private setupExpandableFilter() {
        this.expandableFilter.initialize(this.panelFilterHeader, this.panelFilterContent);
        this.expandableFilter.setSearchBordersExpanded();
        this.expandableFilter.toggle(false);
        this.expandableFilter.onClear = (event) => {
            this.buttonClearOnClick(event);
        }
    }

    async searchList() {
        const currentPositions = this.switchCurrentPositions.checked;
        const groupsLookupData = this.textboxGroups.lookupModelData;
        const unitsLookupData = this.textboxUnit.lookupModelData;
        const driversLookupData = this.textboxDriver.lookupModelData;
        let groupArray: string[];
        let unitArray: string[];
        let driverArray: string[];

        if (groupsLookupData) {
            if (groupsLookupData.length > 1) {
                groupArray = groupsLookupData.map(item => item.get("id"));
            } else {
                groupArray = [groupsLookupData[0].get("id")]
            }
        }

        if (unitsLookupData) {
            if (unitsLookupData.length > 1) {
                unitArray = unitsLookupData.map(item => item.get("id"));
            } else {
                unitArray = [unitsLookupData[0].get("id")]
            }
        }

        if (driversLookupData) {
            if (driversLookupData.length > 1) {
                driverArray = driversLookupData.map(item => item.get("id"));
            } else {
                driverArray = [driversLookupData[0].get("id")]
            }
        }

        const dateRange = DateRange.parseFormattedDateRange(this.textboxDateRange.getDataValue()) as DateRange;

        this.layoutAll.tableMobileCommPosition.busy = true;
        await this.sourceMobileCommPosition.search(
            {
                current_positions: currentPositions,
                mc_groups: groupArray,
                mc_units: unitArray,
                drivers: driverArray,
                start_date: dateRange.startDate ?? null,
                end_date: dateRange.endDate ?? null,
            })
        this.unfilteredData = this.sourceMobileCommPosition.data
        this.layoutAll.tableMobileCommPosition.busy = false;
        this.mapAllLandmarks();
    }

    filterData() {
        this.sourceMobileCommPosition.data = this._unfilteredData;

        const dataAll = this._unfilteredData;
        const dataTractors = [];
        const dataDrivers = [];
        const dataTrailers = [];

        this._unfilteredData.forEach((row) => {
            if (row.data["mc_unit_type"] == 'T') {
                dataTractors.push(row);
            }
            if (row.data["mc_unit_type"] == 'L') {
                dataTrailers.push(row);
            }
            if (row.data["mc_unit_type"] == 'D') {
                dataDrivers.push(row);
            }
        });

        [{ layout: this.layoutAll, data: dataAll },
        { layout: this.layoutTractors, data: dataTractors },
        { layout: this.layoutDrivers, data: dataDrivers },
        { layout: this.layoutTrailers, data: dataTrailers }
        ].forEach(({ layout, data }, i) => {
            layout.sourceMobileCommPosition.setRowsAndMode(DataSourceMode.NONE, data);
            layout.isFindNearData = false;
            const tab: Tab = this.tabsetMobileCommPositionList.getTab(i);
            const captionTokens = tab.caption.split(' ')
            const captionLastTokenIsNaN = isNaN(+captionTokens.pop());

            const unitSet = new Set<string>();
            data.forEach(row => unitSet.add(row.get("mc_unit_no")));
            tab.caption = captionLastTokenIsNaN
                ? `${tab.caption} ${data.length}`
                : `${captionTokens.join(' ')} ${unitSet.size}`

            if (data.length > 0 && data[0].data["find_near_dist"]) {
                layout.tableMobileCommPosition.applySort("find_near_dist", "asc", true);
            }
        });
    }

    buttonClearOnClick(event: ClickEvent) {
        this.switchCurrentPositions.checked = true;
        this.textboxDateRange.clear();
        this.textboxGroups.clear();
        this.textboxUnit.clear();
        this.textboxDriver.clear();
    }

    public get unfilteredData(): ModelRow<any>[] {
        return this._unfilteredData;
    }

    public set unfilteredData(newData: ModelRow<any>[]) {
        this._unfilteredData = newData;
        this.filterData();
    }

    switchCurrentPositionsOnChange(event: ChangeEvent) {
        this.textboxDriver.visible = !this.switchCurrentPositions.checked;
        this.textboxDriver.clear();
        this.textboxUnit.visible = !this.switchCurrentPositions.checked;
        this.textboxUnit.clear();
        this.textboxDateRange.visible = !this.switchCurrentPositions.checked;
        this.textboxDateRange.clear();
    }
}
